import React from 'react';
import { DayPicker } from 'react-day-picker';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { cn } from '../../shared/util/cn';
import 'react-day-picker/dist/style.css';

export interface DatePickerProps {
  selected?: Date;
  onSelect?: (date: Date | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  mode?: 'single' | 'range';
}

export const DatePicker: React.FC<DatePickerProps> = ({
  selected,
  onSelect,
  placeholder = 'Seleziona una data',
  disabled,
  className,
  mode = 'single',
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className={cn('relative', className)}>
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className={cn(
          'flex h-10 w-full items-center justify-between rounded-2xl border-2 border-[var(--color-mockup-border)] bg-surface px-4 py-2 text-sm',
          'ring-offset-surface placeholder:text-[var(--color-mockup-text-light)]',
          'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:border-primary',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'dark:border-[var(--color-mockup-border)] dark:focus:ring-primary'
        )}
      >
        <span className={selected ? 'text-[var(--color-mockup-text)] font-medium' : 'text-[var(--color-mockup-text-light)]'}>
          {selected ? dayjs(selected).locale('it').format('DD/MM/YYYY') : placeholder}
        </span>
        <svg
          className="h-4 w-4 opacity-50"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      </button>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute z-50 mt-1 rounded-2xl border-2 border-[var(--color-mockup-border)] bg-surface shadow-dropdown overflow-hidden">
            <DayPicker
              mode={mode}
              selected={selected}
              onSelect={(date) => {
                if (onSelect) {
                  onSelect(date as Date | undefined);
                }
                if (mode === 'single') {
                  setIsOpen(false);
                }
              }}
              className="p-3"
            />
          </div>
        </>
      )}
    </div>
  );
};
